<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { mapGetters } from 'vuex'

@Component({
    props: {
        observation: Object
    }
})

export default class ObservationCard extends Vue {
    domains = [
        {
            name: "Planning & Preparation",
            components: [
                { description: "1a", id: [23, 24] }, 
                { description: "1e", id: [31, 32] }
            ]
        },
        {
            name: "Classroom Environment",
            components: [
                { description: "2a", id: 25 }, 
                { description: "2d", id: 26 }
            ]
        },
        {
            name: "Instruction",
            components: [
                { description: "3b", id: 27 }, 
                { description: "3c", id: 28 },
                { description: "3d", id: 29 }
            ]
        },
        {
            name: "Professional Responsibilities",
            components: [
                { description: "4e", id: [30, 33] }
            ]
        }
    ]

    observationDate(observation) {
        return `${observation.MOTPMonth} ${observation.MOTPDay}`
    }
    
    componentIsMeasured(input, observation) {
        if (typeof input === 'object') {
            let components = observation.componentsMeasured.filter(component => 
                component.MOTPComponentID === input[0] || 
                component.MOTPComponentID === input[1]
            )
            return components[0].Rating > 0 || components[1].Rating > 0
                ? true : false
        } else {
            let component = observation.componentsMeasured.find(component => 
                component.MOTPComponentID === input
            )
            return component.Rating > 0 ? true : false
        }
    }
}
</script>
<template>
    <div class="card">
        <p>{{ observationDate(observation) }}</p>
        <div class="card-components">
            <ul>
                <li v-for="domain in domains" :key="domain.name">
                    <ul>
                        <li v-for="(component, index) in domain.components" :key="index">
                            <span :class="{ 'measured': componentIsMeasured(component.id, observation)}">
                                {{ component.description }}
                            </span>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div> 
</template>
<style scoped lang="scss">
    .card {
        width: 203px;
        height: 246px;
        border: 1px solid #979797;
        box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.5);
        background-color: #fff;
        padding: 10px;
        cursor: pointer;
        &:hover {
            background-color: #e7dbee;
        }
        p {
            text-align: center;
            margin: 0 0 20px 0;
            font-family: 'museo_sans', sans-serif;
            font-size: 24px;
        }
        .card-components {
            min-height: 175px;
            ul {
                padding: 0;
                list-style: none;
                box-sizing: border-box;
            }
            ul > li {
                height: 35px;
                padding-bottom: 5px;
                ul {
                    padding: 5px;
                }
                ul > li {
                    display: inline;
                    span {
                        font-family: 'museo_slab', sans-serif;
                        display: inline-block;
                        height: 20px;
                        width: 20px;
                        font-size: 15px;
                        padding: 5px;
                        border-radius: 17px;
                        margin-right: 5px;
                        border: 1px solid #979797;
                        &.measured {
                            background-color: #613f75;
                            color: #fff;
                        }
                    }
                }
            }
        }
    }
</style>